const gallery = [
  {
    id: 1,
    name: "London",
    image: "/assets/gallery/gtl/1.jpg",
  },
  {
    id: 2,
    name: "London",
    image: "/assets/gallery/gtl/2.jpg",
  },
  {
    id: 3,
    name: "Turkey",
    image: "/assets/gallery/gtl/3.jpg",
  },
  {
    id: 4,
    name: "Thailand",
    image: "/assets/gallery/gtl/4.jpg",
  },
  {
    id: 5,
    name: "Thailand",
    image: "/assets/gallery/gtl/5.jpg",
  },
  {
    id: 6,
    name: "Spain",
    image: "/assets/gallery/gtl/6.jpg",
  },
  {
    id: 7,
    name: "Spain",
    image: "/assets/gallery/gtl/7.jpg",
  },
  {
    id: 8,
    name: "Switzerland",
    image: "/assets/gallery/gtl/8.jpg",
  },
  {
    id: 9,
    name: "Switzerland",
    image: "/assets/gallery/gtl/9.jpg",
  },
  {
    id: 10,
    name: "France",
    image: "/assets/gallery/gtl/10.jpg",
  },
  {
    id: 11,
    name: "United State of America",
    image: "/assets/gallery/gtl/11.jpg",
  },
  {
    id: 12,
    name: "Pakistan",
    image: "/assets/gallery/gtl/12.jpg",
  },
];
export default gallery;
